import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { WallFolderWithWeatherRelations } from 'types';

export const getWeatherFolders = async (
  userId: number | undefined
): Promise<WallFolderWithWeatherRelations[]> => {
  if (userId === undefined) return [];
  const { data } = await axios.get(`/api/users/${userId}/folders/weather`);
  return data as WallFolderWithWeatherRelations[];
};

type QueryFnType = typeof getWeatherFolders;

type UseWeatherFoldersOptions = {
  userId: number | undefined;
  config?: QueryConfig<QueryFnType>;
};

export const useWeatherFolders = ({
  userId,
  config,
}: UseWeatherFoldersOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['weatherFolders', userId],
    queryFn: () => getWeatherFolders(userId),
  });
};
